import axios from 'axios';
import { commonReject, commonReject2 } from '../../utils/api';
import {
  LIBRARY_CATEGORIES,
  LIBRARY_CATEGORIES_V1,
  V1_CATEGORY_BY_ID,
  CATEGORY_ALL_OUTLETS,
  ASSIGN_TO_ITEM,
  V1_CATEGORIES_WITH_UNCATEGORIZED,
  LIBRARY_CATEGORIES_INTERSECT_ITEMS,
} from './constants';

/**
 * @see https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v2/categories_controller.rb#L5
 * @param params
 * @return {Axios.IPromise<U>}
 */

export function getCategories(params) {
  return axios
    .get(LIBRARY_CATEGORIES, { params, withCredentials: true })
    .catch(commonReject);
}

export function getCategoriesV1(params) {
  return axios
    .get(LIBRARY_CATEGORIES_V1, { params, withCredentials: true })
    .catch(commonReject);
}

/**
 * https://github.com/mokapos/moka-rails/blob/master/app/controllers/api/v1/categories_controller.rb#L88
 * @param id
 * @param params
 * @return {Axios.IPromise<U>}
 */
export function getCategoryDetail(id, params?) {
  return axios
    .get(V1_CATEGORY_BY_ID(id), { params, withCredentials: true })
    .catch(commonReject);
}

export function categoryRequestWithKeywordAndType(params) {
  return axios
    .get(LIBRARY_CATEGORIES_V1, { params, withCredentials: true })
    .catch(commonReject);
}

export function updateCategory(id, data, params?) {
  return axios
    .put(V1_CATEGORY_BY_ID(id), data, { params, withCredentials: true })
    .catch(commonReject2);
}

export function createCategory(data, params?) {
  return axios
    .post(LIBRARY_CATEGORIES_V1, data, { params, withCredentials: true })
    .catch(commonReject2);
}

export function createCategoryAllOutlets(data, params?) {
  return axios
    .post(CATEGORY_ALL_OUTLETS, data, { params, withCredentials: true })
    .catch(commonReject2);
}

export function deleteCategory(id, params?) {
  return axios
    .delete(V1_CATEGORY_BY_ID(id), { params, withCredentials: true })
    .catch(commonReject2);
}

export function assignToItem(id, data, params?) {
  return axios
    .put(ASSIGN_TO_ITEM(id), data, { params, withCredentials: true })
    .catch(commonReject2);
}

export function getCategoriesWithUncategorizedV1(params?) {
  return axios
    .get(V1_CATEGORIES_WITH_UNCATEGORIZED, { params, withCredentials: true })
    .catch(commonReject2);
}

export function getCategoriesV1IntersectingItems(params, outletIds) {
  return axios
    .get(LIBRARY_CATEGORIES_INTERSECT_ITEMS, {
      params,
      withCredentials: true,
      headers: { OUTLET_IDS: outletIds },
    })
    .catch(commonReject);
}
